import React, {useEffect, useRef, useState} from 'react';
import Swiper from 'react-id-swiper';
import 'swiper/swiper-bundle.css';
import "./Profile.scss";
import {Nav} from "../../Components";
import {useHistory} from "react-router";
import ReactGA from "react-ga";
import {Tabs, Spin, Popconfirm,message} from 'antd';
import 'antd/dist/antd.css';
import {ConvertTMonthName, editUser, getUser, userProfile} from "../../Services";
import moment from "moment-jalaali";
import DatePicker,{Calendar} from 'react-datepicker2';
import toaster from "toasted-notes";
import {
    ChangeDefaultAddress,
    DeleteOnlineAddress, GetBasket,
    StoreOnlineAddress
} from "../../Components/OnlineAddress/OnlineAddressService";
import useWindowDimensions from "../../hooks/useWindowDimensions";


const { TabPane } = Tabs;


function Success(props) {
    return(
        <div className="success_message-container">
            <span className="text-message">{props.message}</span>
        </div>
    )
}

function Error(props) {

    return(
        <div className="error_message-container">
            <span className="text-message">{props.message}</span>
        </div>
    )
}


function callback(key) {
    console.log(key);
}

const ConvertToJalaliSplited = (date) =>{
    if(date){
        let month = moment.utc(date.split('+')[0]).format('jMM');
        let year = moment.utc(date.split('+')[0]).format('jYYYY');
        let day = moment.utc(date.split('+')[0]).format('jDD');
        return year+"-"+month+"-"+day
    }
    return ""
}



const ConvertToMiladiSplited = (date) =>{
    if(date){
        let month = moment.utc(date.split('+')[0]).format('MM');
        let year = moment.utc(date.split('+')[0]).format('YYYY');
        let day = moment.utc(date.split('+')[0]).format('DD');
        return year+"-"+month+"-"+day
    }
    return ""
}

function Profile() {

    const history = useHistory()
    const fileInput = useRef(null)
    const [activeTab,set_activeTab] = useState(3)
    const [user,set_user] = useState({})
    const [userLoading,set_userLoading] = useState(false)
    const [userPicLoading,set_userPicLoading] = useState(false)
    const [addressList,set_addressList] = useState([])
    const [defAddress,set_defAddress] = useState({})
    const [addressLoading,set_addressLoading] = useState(false)

    const [bir,set_bir] = useState(moment())


  useEffect(()=>{
      getUserFunc()
      getAddressFunc()
      Basket()

      //set active tab
      const tab = localStorage.getItem('active_tab');
      if(tab){
          set_activeTab(parseInt(tab))
      }
  },[])

    const getAddressFunc = async () =>{
        try{
            let resp = await StoreOnlineAddress()
            console.log("Address",resp)
            set_addressList(resp.data)

        }catch (e) {
            console.log(e)
        }
    }

    const getUserFunc = async () =>{
        try{
            let resp = await getUser()
            console.log("User",resp)
            if(!resp.data.birthday_date){resp.data.birthday_date = ""}else {
                let date = ConvertToJalaliSplited(resp.data.birthday_date)
                 set_bir(moment(date, 'jYYYY-jM-jD'))
            }
            set_user(resp.data)
        }catch (e) {
            console.log(e)
        }
    }

    function validateEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    const editUserFunc = async () =>{
        set_userLoading(true)
        if(!user.first_name){
            toaster.notify(({ onClose }) => (<Error   message={"نام خود را وارد نمایید"}/>),{duration: 2000});
            set_userLoading(false)
            return;
        }

        if(!user.last_name){
            toaster.notify(({ onClose }) => (<Error   message={"نام خانوادگی خود را وارد نمایید"}/>),{duration: 2000});
            set_userLoading(false)
            return;
        }

        // if(!validateEmail(user.email)){
        //     toaster.notify(({ onClose }) => (<Error   message={"ایمیل را صحیح وارد نمایید"}/>),{duration: 2000});
        //     set_userLoading(false)
        //     return
        // }


        console.log("tavvvv : ",user.birthday_date)

         // user.birthday_date = ""
        if(!user.birthday_date || user.birthday_date.length< 1){
            delete user.birthday_date
        }

        if(user.birthday_date && user.birthday_date.length>12){
            // set_user({...user,birthday_date:ConvertToJalaliSplited(user.birthday_date)})
            user.birthday_date = ConvertToMiladiSplited(user.birthday_date)
        }

        if(!user.gender)
            user.gender="male"

        try{
            let resp = await editUser(user)
            message.success('پروفایل با موفقیت ویرایش شد');
            localStorage.setItem('user',JSON.stringify(user));
            set_userLoading(false)
        }catch (e) {
            message.error('مشکل در ویرایش پروفایل');
            set_userLoading(false)
            console.log(e)
        }
    }



    const upload = async (e) =>{
        set_userPicLoading(true)
        let file = e.target.files[0];
        const data = new FormData();
        data.append('image', file);
        try{
            let resp = await userProfile(data)
            console.log("Resp : ",resp)
            set_userPicLoading(false)
            set_user({...user,image:resp.data.image})
            localStorage.setItem('user',JSON.stringify({...user,image:resp.data.image}));
        }catch (e) {
            set_userPicLoading(false)
            console.log(e);
        }
    }

    //delete Address
    const deleteAddress = async (id)=>{
        try{
            const resp = await DeleteOnlineAddress(id);
            console.log("Address delete : ",resp)
            getAddressFunc()
        }catch (e) {
            console.log("Error : ",e)
        }


    }

    // default address
    const defaultAddress = async (id) =>{
        set_addressLoading(true)
        try {
            const resp = await ChangeDefaultAddress(id)
            console.log("default : ",resp)
            Basket()
            set_addressLoading(false)
        }catch (e) {
            console.log(e)
            set_addressLoading(false)
        }

    }

    const Basket = async ()=>{
        const response = await GetBasket()
        // console.log("basket : ",response.data)
        if(response.data.address){
            set_defAddress(response.data.address)
        }
    }


    const { height, width,mobileWidth } = useWindowDimensions();

    return(
        <div className="profile-wrapper" >
            <div className="profile-container" >
                <div className="report-header" >
                    <span>حساب کاربری</span>
                    <i
                        onClick={() => history.goBack()}
                        className="fa fa-arrow-left"></i>
                </div>

                <div className="profile-tabs">
                    {/*<div className={activeTab===1?"profile-tabs-item profile-tabs-item-active":"profile-tabs-item"}  onClick={()=>{*/}
                    {/*    set_activeTab(1);*/}
                    {/*    localStorage.setItem('active_tab',"1")*/}
                    {/*}}>*/}
                    {/*    <span>کارت های من</span>*/}
                    {/*</div>*/}
                    <div className={activeTab===2?"profile-tabs-item profile-tabs-item-active":"profile-tabs-item"}  onClick={()=>{
                        set_activeTab(2);
                        localStorage.setItem('active_tab',"2")
                    }}>
                        <span>آدرس های من</span>
                    </div>
                    <div className={activeTab===3?"profile-tabs-item profile-tabs-item-active":"profile-tabs-item"}  onClick={()=>{
                        set_activeTab(3);
                        localStorage.setItem('active_tab',"3")
                    }}>
                        <span>اطلاعات من</span>
                    </div>
                </div>

                {activeTab===1?<div className="card-tab">
                    <div className="card-tab-message">
                        <span>هیچ کارتی وجود ندارد</span>
                    </div>
                </div>:null}

                {activeTab===2?
                    <Spin spinning={addressLoading}>
                        <div className="address-tab">
                            <div className="address-tab-list">
                                {addressList.map(i=>{
                                    return(
                                        <div className="address-tab-item" style={i.uid===defAddress.uid?{backgroundColor:"antiquewhite"}:{}} onClick={()=>{
                                            defaultAddress(i.uid)
                                        }}>
                                            <div className="address-tab-actions">
                                                <i className="fa fa-trash" onClick={()=>deleteAddress(i.uid)}></i>
                                                {/*<i className="fa fa-edit"></i>*/}
                                                {/*<i className="fa fa-map"></i>*/}
                                            </div>
                                            <div className="address-tab-info">
                                                <span className="title">{i.province.title+" - "+i.city.title}</span>
                                                <span className="address-label">{i.address}</span>
                                                <span>{i.postal_code}</span>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                            <div className="profile-add-address-btn" onClick={()=>{
                                history.push("/online-store-address")
                            }}>
                                <i className="fa fa-plus"></i>
                            </div>
                        </div>
                    </Spin>
                    :null}

                {activeTab===3?<div className="info-tab">



                    <Spin spinning={userLoading}>
                        <div className="info-wr">
                            <div className="info-tab-list">

                                <div className="info-tab-item">
                                    <Spin spinning={userPicLoading}>
                                        <div className="img-sec">
                                            <img src={user.image} alt=""/>
                                            <input type="file" name="" id=""  style={{display:'none'}} ref={fileInput}  onChange={upload}/>
                                            <i className="fa fa-camera" onClick={()=>{
                                                fileInput.current.click()
                                            }}></i>
                                        </div>
                                    </Spin>
                                </div>

                                <div className="info-tab-item-input">
                        <span onClick={()=>{
                            console.log(user)
                        }}>نام</span>
                                    <div className="input-sec">
                                        <input
                                            value={user.first_name}
                                            onChange={e=>set_user({...user,first_name:e.target.value})}
                                            type="text" name="" id="" placeholder="نام  خود را وارد نمایید" />
                                    </div>
                                </div>

                                <div className="info-tab-item-input">
                                    <span>نام خانوادگی</span>
                                    <div className="input-sec">
                                        <input type="text"
                                               value={user.last_name}
                                               onChange={e=>set_user({...user,last_name:e.target.value})}
                                               name="" id=""  placeholder="نام خانوادگی خود را وارد نمایید"/>
                                    </div>
                                </div>

                                <div className="info-tab-item-input">
                                    <span>ایمیل</span>
                                    <div className="input-sec">
                                        <input
                                            value={user.email}
                                            onChange={e=>set_user({...user,email:e.target.value})}
                                            type="text" name="" id=""  placeholder="ایمیل خود را وارد نمایید"/>
                                    </div>
                                </div>

                                <div className="info-tab-item-input">
                                    <span>جنسیت</span>
                                    <div className="input-sec">
                                        <select
                                            className="gender-select"
                                            value={user.gender}
                                            onChange={e=>set_user({...user,gender:e.target.value})}
                                            name="" id="">
                                            <option value="male">مرد</option>
                                            <option value="female">زن</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="info-tab-item-input">
                                    <span className="info-tab-title">تاریخ تولد</span>
                                    <span className="info-tab-message">تاریخ تولدتان را ثبت کرده و منتظر سورپرایز ما باشید!</span>
                                    <div className="input-sec">
                                        {/*<input*/}

                                        {/*    value={user.birthday_date}*/}
                                        {/*    onChange={e=>set_user({...user,birthday_date:e.target.value})}*/}
                                        {/*    style={{direction:"rtl",fontFamily:"Arial"}} type="text" name="" id=""  placeholder="XX-XX-XX"/>*/}

                                        <DatePicker
                                            inputJalaaliFormat="jYYYY-jMM-jDD"
                                            timePicker={false}
                                            isGregorian={false}
                                            onChange={value => {
                                                console.log("GGG : ",value)
                                                set_user({...user,birthday_date:moment(value).format("YYYY-MM-DD")})
                                                set_bir(value)
                                            }}
                                            value={bir}
                                        />
                                    </div>
                                </div>

                                <div className="info-tab-item-input">

                                    <Popconfirm
                                        title="آیا شما از خروج از حساب کاربری خود اطمینان دارید ؟"
                                        onConfirm={e=>{
                                            localStorage.clear();
                                            history.push("/login")
                                        }}
                                        onCancel={e=>{
                                            console.log("cancel")
                                        }}
                                        okText="بله"
                                        cancelText="خیر"
                                    >
                                        <span  className="logout-link" >خروج از حساب کاربری</span>
                                    </Popconfirm>



                                </div>

                                <div className="info-tab-item">
                                    <div className="btn-sec"
                                         // style={{width:mobileWidth?mobileWidth:document?.getElementById('mobile-sec')?.clientWidth}}
                                    >
                                        <div className="btn-wr" style={{width:300}} onClick={()=>{
                                            editUserFunc()
                                        }}>
                                            <span>تایید</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </Spin>

                </div>:null}



            </div>
        </div>
    )
}

export {Profile};
